import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import FromSelection from '../../../../components/ResourceSelector/DrivePicker/FromSelection';
import Utils from '../../../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { config },
		driveList,
		selection,
	} = state;
	const { breadcrumbs } = driveList;

	return {
		selectionIds: selection.resources,
		driveList,
		sharedDirId: Utils.getSharedDirId(driveList, config),
		sourcesDirId: Utils.getSourcesDirId(driveList, config),
		currentDriveId: breadcrumbs.length === 0
			? undefined
			: breadcrumbs[breadcrumbs.length - 1].id,
	};
};

export default connect(mapStateToProps)(FromSelection);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ResourceSelector/DrivePicker/FromSelection/index.tsx